
import React, { Component } from 'react';
import { AsyncAutocompleteWidget2 } from 'form/AutocompleteWidget2';


const filterFieldStyle = {
  minWidth: 200,
  maxWidth: 280,
  flex: '1 1 200px'
};


export class ScheduleListTableFilter extends Component {

  render() {
    const { context } = this.props;
    const filter = context.filter;

    return (
      <>
        <div style={filterFieldStyle}>
          <AsyncAutocompleteWidget2
            url={'fleet/truck'}
            optionLabel={'label'}
            value={filter.tractor_unit}
            size={'small'}
            label={'ТС'}
            onChange={(value) => context.setFilterValue('tractor_unit', value)}
          />
        </div>
        <div style={filterFieldStyle}>
          <AsyncAutocompleteWidget2
            url={'fleet/driver/?is_fired=False'}
            optionLabel={'short_name'}
            value={filter.driver}
            size={'small'}
            label={'Водитель'}
            onChange={(value) => context.setFilterValue('driver', value)}
          />
        </div>
        <div style={filterFieldStyle}>
          <AsyncAutocompleteWidget2
            url={'fleet/trailer'}
            optionLabel={'label'}
            value={filter.semi_trailer}
            size={'small'}
            label={'Полуприцеп'}
            onChange={(value) => context.setFilterValue('semi_trailer', value)}
          />
        </div>
      </>
    )
  }
}
